export default __webpack_public_path__ + "static/bg-credit-score--mobile-1aeac91bafb03bcc0025b3582668d9c3.jpg";